import { useMemo } from 'react';
import { type VehicleCycledEnergyRecord } from '../services/battery-monitoring-api/types/battery-monitoring-api';

export type CustomerNameVehicle = Pick<VehicleCycledEnergyRecord, 'customer' | 'customerCountry' | 'chassisNumber'>;

interface UseCustomerNames {
  vehicles: CustomerNameVehicle[] | undefined;
  selectedCountries: string[];
}

const useCustomerNames = ({ vehicles, selectedCountries }: UseCustomerNames): string[] => {
  return useMemo<string[]>(() => {
    if (!vehicles) return [];

    const unique = new Set<string>();

    for (const vehicle of vehicles) {
      if (vehicle.customerCountry && vehicle.customer.trim()) {
        if (selectedCountries.length > 0 && !selectedCountries.includes(vehicle.customerCountry)) {
          continue;
        }
        unique.add(vehicle.customer);
      }
    }

    return [...unique].toSorted((a, b) => a.localeCompare(b));
  }, [vehicles, selectedCountries]);
};

export default useCustomerNames;
